module.exports = __webpack_public_path__ + "media/images/emblems/Erlach-coat_of_arms-0840f64af08b02ce39e72bb0f2fba654.svg";